import { forwardRef } from 'react';
import MaterialTableRow, { TableRowProps } from '@mui/material/TableRow';

export const TableRow = forwardRef<HTMLTableRowElement, TableRowProps>(
    (props, ref) => {
        return (
            <MaterialTableRow
                ref={ref}
                data-testid={'TableRow-container'}
                {...props}
            />
        );
    }
);

export default TableRow;
